/* GOPSHOP – Story-Kreise + Story-Viewer (sections/gop-stories.liquid)
   Tippen rechts/links = weiter/zurück, Halten = Pause, nach unten wischen / ESC = schließen.
   Ein gemeinsamer Viewer für alle Instanzen; gesehene Stories in localStorage (nur IDs). */
(function () {
  'use strict';

  var SEEN_KEY = 'gop-stories-seen';
  var SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON_X = SVG + '<path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_L = SVG + '<path d="m15 18-6-6 6-6"/></svg>';
  var ICON_R = SVG + '<path d="m9 6 6 6-6 6"/></svg>';

  function readSeen() {
    try {
      return JSON.parse(window.localStorage.getItem(SEEN_KEY) || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function markSeen(id) {
    var s = readSeen();
    if (s.indexOf(id) >= 0) return;
    s.push(id);
    if (s.length > 200) s = s.slice(-200);
    try {
      window.localStorage.setItem(SEEN_KEY, JSON.stringify(s));
    } catch (e) {
      /* privat / blockiert */
    }
  }

  var v = null;

  function q(sel) {
    return v.el.querySelector(sel);
  }

  function buildViewer() {
    var el = document.createElement('div');
    el.className = 'gstv';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="gstv__bg" data-gstv-bg></div>' +
      '<button type="button" class="gstv__arrow gstv__arrow--prev" data-gstv-prev>' + ICON_L + '</button>' +
      '<div class="gstv__frame" data-gstv-frame>' +
      '<div class="gstv__media"><div class="gstv__media-bg" data-gstv-mbg></div><img class="gstv__img" data-gstv-img alt="" draggable="false"></div>' +
      '<div class="gstv__bars" data-gstv-bars></div>' +
      '<div class="gstv__top"><img class="gstv__ava" data-gstv-ava alt=""><span class="gstv__who"><b>GOPSHOP</b><small data-gstv-handle></small></span>' +
      '<button type="button" class="gstv__close" data-gstv-close>' + ICON_X + '</button></div>' +
      '<button type="button" class="gstv__tap gstv__tap--prev" data-gstv-prev></button>' +
      '<button type="button" class="gstv__tap gstv__tap--next" data-gstv-next></button>' +
      '<div class="gstv__foot"><p class="gstv__title" data-gstv-title></p><p class="gstv__text" data-gstv-text></p>' +
      '<a class="gop-btn gop-btn--primary gstv__cta" data-gstv-cta></a></div>' +
      '</div>' +
      '<button type="button" class="gstv__arrow gstv__arrow--next" data-gstv-next>' + ICON_R + '</button>';
    document.body.appendChild(el);
    v = { el: el, data: [], i: 0, open: false, held: false, suppress: false };
    v.img = q('[data-gstv-img]');
    v.bars = q('[data-gstv-bars]');
    v.frame = q('[data-gstv-frame]');

    function done() {
      el.classList.remove('is-loading');
    }
    v.img.addEventListener('load', done);
    v.img.addEventListener('error', done);

    el.addEventListener('click', function (e) {
      if (v.suppress) {
        v.suppress = false;
        if (e.target.closest('[data-gstv-prev],[data-gstv-next]')) return;
      }
      if (e.target.closest('[data-gstv-close]')) return close();
      if (e.target.closest('[data-gstv-prev]')) return show(v.i - 1);
      if (e.target.closest('[data-gstv-next]')) return show(v.i + 1);
      if (e.target.closest('[data-gstv-cta]')) return follow(e, v.data[v.i]);
      if (e.target === el || e.target.classList.contains('gstv__bg')) close();
    });

    v.bars.addEventListener('animationend', function () {
      if (v.open) show(v.i + 1);
    });

    /* Halten = Pause, nach unten wischen = schließen */
    var sy = 0;
    var sx = 0;
    var holdT = 0;
    var dragging = false;
    v.frame.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-gstv-close],[data-gstv-cta]')) return;
      sy = e.clientY;
      sx = e.clientX;
      dragging = true;
      v.held = false;
      clearTimeout(holdT);
      holdT = setTimeout(function () {
        v.held = true;
        el.classList.add('is-paused');
      }, 220);
    });
    v.frame.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dy = e.clientY - sy;
      if (Math.abs(e.clientX - sx) > 12 || dy > 12) clearTimeout(holdT);
      if (dy > 0) v.frame.style.transform = 'translateY(' + dy * 0.6 + 'px) scale(' + (1 - Math.min(dy, 300) / 3000) + ')';
    });
    function end(e) {
      if (!dragging) return;
      dragging = false;
      clearTimeout(holdT);
      var dy = e.clientY - sy;
      v.frame.style.transform = '';
      if (v.held) {
        v.held = false;
        v.suppress = true;
        el.classList.remove('is-paused');
      }
      if (dy > 90) {
        v.suppress = true;
        close();
      }
    }
    v.frame.addEventListener('pointerup', end);
    v.frame.addEventListener('pointercancel', end);

    document.addEventListener('keydown', function (e) {
      if (!v.open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(v.i + 1);
      else if (e.key === 'ArrowLeft') show(v.i - 1);
      else if (e.key === 'Tab') trap(e);
    });
    document.addEventListener('visibilitychange', function () {
      if (v.open) el.classList.toggle('is-paused', document.hidden);
    });
    return v;
  }

  function trap(e) {
    var f = Array.prototype.filter.call(v.el.querySelectorAll('button, a[href]'), function (n) {
      return n.offsetParent !== null && !n.hidden;
    });
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function show(i) {
    if (!v || !v.open) return;
    if (i < 0) i = 0;
    if (i >= v.data.length) return close();
    v.i = i;
    var s = v.data[i];
    var bars = v.bars.children;
    for (var j = 0; j < bars.length; j++) {
      bars[j].classList.toggle('is-done', j < i);
      bars[j].classList.remove('is-active');
    }
    if (bars[i]) {
      void bars[i].offsetWidth;
      bars[i].classList.add('is-active');
    }
    if (v.img.getAttribute('src') === s.img && v.img.complete) v.el.classList.remove('is-loading');
    else {
      v.el.classList.add('is-loading');
      v.img.src = s.img;
    }
    var bg = 'url("' + String(s.img).replace(/"/g, '%22') + '")';
    q('[data-gstv-bg]').style.backgroundImage = bg;
    q('[data-gstv-mbg]').style.backgroundImage = bg;
    q('[data-gstv-title]').textContent = s.title || '';
    q('[data-gstv-text]').textContent = s.text || '';
    var cta = q('[data-gstv-cta]');
    cta.hidden = !s.link;
    if (s.link) {
      cta.href = s.link;
      cta.textContent = s.cta || s.title || '';
    }
    if (s.id) {
      markSeen(s.id);
      if (v.root) {
        var it = v.root.querySelector('[data-id="' + s.id + '"]');
        if (it) it.classList.add('is-seen');
      }
    }
    var nx = v.data[i + 1];
    if (nx && nx.img) new Image().src = nx.img;
  }

  /* Story-Button: Sprung auf derselben Seite (/#gop-dyson), Wunschformular (#gop-wish) vorbefüllen */
  function follow(e, s) {
    var link = (s && s.link) || '';
    var at = link.indexOf('#');
    var hash = at >= 0 ? link.slice(at + 1) : '';
    close(true);
    if (!hash) return;
    if (hash === 'gop-wish' && window.gopAskWish) {
      e.preventDefault();
      window.gopAskWish(s.title);
      return;
    }
    var t = window.gopReveal ? window.gopReveal(hash) : document.getElementById(hash);
    if (t) {
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function open(root, data, i, opener) {
    if (!v) buildViewer();
    v.root = root;
    v.data = data;
    v.opener = opener;
    v.el.style.setProperty('--gstv-dur', (+root.getAttribute('data-dur') || 5) + 's');
    v.el.setAttribute('aria-label', root.getAttribute('data-t-label') || 'Stories');
    q('[data-gstv-close]').setAttribute('aria-label', root.getAttribute('data-t-close') || 'Close');
    v.el.querySelectorAll('[data-gstv-prev]').forEach(function (b) {
      b.setAttribute('aria-label', root.getAttribute('data-t-prev') || 'Previous');
    });
    v.el.querySelectorAll('[data-gstv-next]').forEach(function (b) {
      b.setAttribute('aria-label', root.getAttribute('data-t-next') || 'Next');
    });
    q('[data-gstv-ava]').src = root.getAttribute('data-ava') || '';
    q('[data-gstv-handle]').textContent = '@' + (root.getAttribute('data-handle') || 'gopshop.service');
    v.bars.innerHTML = data
      .map(function () {
        return '<span class="gstv__bar"><i></i></span>';
      })
      .join('');
    v.open = true;
    v.el.classList.remove('is-paused');
    v.el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gst-lock');
    requestAnimationFrame(function () {
      v.el.classList.add('is-open');
    });
    show(i);
    try {
      q('[data-gstv-close]').focus({ preventScroll: true });
    } catch (e) {
      /* alte Browser */
    }
  }

  function close(keepFocus) {
    if (!v || !v.open) return;
    v.open = false;
    v.el.classList.remove('is-open', 'is-paused');
    v.el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gst-lock');
    Array.prototype.forEach.call(v.bars.children, function (b) {
      b.classList.remove('is-active');
    });
    if (!keepFocus && v.opener) {
      try {
        v.opener.focus({ preventScroll: true });
      } catch (e) {
        /* egal */
      }
    }
  }

  function init(root) {
    if (root.__gst) return;
    root.__gst = true;
    var data = [];
    try {
      data = JSON.parse(root.querySelector('[data-gst-json]').textContent) || [];
    } catch (e) {
      data = [];
    }
    var seen = readSeen();
    root.querySelectorAll('[data-gst-i]').forEach(function (a) {
      if (seen.indexOf(a.getAttribute('data-id')) >= 0) a.classList.add('is-seen');
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        root.classList.toggle('is-idle', !en[0].isIntersecting);
      }).observe(root);
    }
    var viewer = root.getAttribute('data-viewer') === 'true';
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-gst-i]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      /* 7.4: Kreis „Mystery-Box“ → 3D-Box als Vollbild (sections/gop-mystery.liquid); fehlt der Bereich, gilt der Link */
      if (a.hasAttribute('data-m3d') && window.gopMys3D && window.gopMys3D.open(a)) {
        e.preventDefault();
        markSeen(a.getAttribute('data-id'));
        a.classList.add('is-seen');
        return;
      }
      if (!viewer) return;
      var i = +a.getAttribute('data-gst-i');
      if (!data[i] || !data[i].img) return;
      e.preventDefault();
      /* Story-Ansicht nur mit Bild-Stories; Symbol-Kreise ohne Bild führen direkt zum Link */
      var list = data.filter(function (d) { return d && d.img; });
      open(root, list, list.indexOf(data[i]), a);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gop-stories]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    close(true);
  });
})();
